import styles from "./SearchView.module.scss";
import SearchForm from "./SearchForm";
import Results from "./Results";

export default function SearchView() {
  return (
    <div className={styles.searchViewContainer}>
      <SearchForm />
      <Results />
    </div>
  );
}
